<template>
  <b-container fluid class="mt-5">
    <h1 class="text-center secondary-text d-block mx-5 font-weight-bolder">محبوب ترین ها</h1>
    <b-row>
      <b-col class="stand-up-animation " lg="4" md="6" v-for="food in getFoods" :key="food.id">
        <b-row class="shadow-lg bg-white rounded-pill my-5 mx-2">
          <b-col cols="8" class="d-flex flex-column align-items-center justify-content-center p-0">
            <router-link class="text-decoration-none text-dark text-center" :to="{name:'Food', params:{slug:food.raw_link}}">
            <span class="food-title justify-center">{{food.name}}</span>
            </router-link>

            <b-row class="d-flex flex-row justify-content-center" v-if="food.rate !== null">
              <div class="justify-center" v-for="i in 5" :key="i">
                <b-icon icon="star-fill" font-scale="1" variant="warning" v-if="i<=food.rate"/>
                <b-icon icon="star" font-scale="1" variant="warning" v-else/>
              </div>
            </b-row>

            <b-row class="d-flex flex-row justify-content-center" v-else>
              <div class="justify-center" v-for="i in 5" :key="i">
                <b-icon icon="star" font-scale="1" variant="warning"/>
              </div>
            </b-row>

            <span class="food-text justify-center" v-if="food.brand !== null">{{ food.brand.name }}</span>
          </b-col>
          <b-col cols="4" class="p-0">
            <b-img fluid :src="food.thumbnail" class="d-block food-img" :alt="food.name" rounded="circle"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "FavoritesContainer",
  computed: {
    getFoods(){
      let foods = []
      let res = this.$store.getters["Product/getFavoriteProducts"]
      res.forEach(element =>{
        if(element.commentable_type.endsWith('Order')){
          foods.push(element.product)
        }else{
          element.commentable.order_products.forEach(product =>{
            foods.push(product)
          })
        }
      })
      return foods
    }
  },
  async mounted() {
    await this.$store.dispatch("Product/getFavoriteProducts")
  }
};
</script>

<style scoped>
.food-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--light-secondary);
}

.food-text {
  font-size: 15px;
  color: var(--dark);
}

.justify-center {
  text-align: center;
}

.food-img{
  width: 100%;
  height: 100%;
}
</style>